import { ProductImageViewModel } from '@/types/api';
import usePDPData from '@/app/(pdp)/_utils/use-pdp-data';
import { VariantContextType } from '@/app/(pdp)/context/types';
import { useVariantContextValues } from '@/app/(pdp)/context/use-variant-context-values';
import { PDPThumbnailType } from '../types';
export function useGallaryItems(contextType: VariantContextType, slug?: string) {
  const {
    data
  } = usePDPData(slug);
  const {
    selectedVariant,
    hasColorOptions
  } = useVariantContextValues(contextType);
  const videos = data?.videos || [];
  const videosThumbnails = videos?.map(({
    id,
    thumbnailImageUrl
  }) => ({
    id: id || '',
    imageUrl: thumbnailImageUrl || '',
    isVideo: true
  }));
  const showSelectedVariantImages = !!hasColorOptions && !!selectedVariant;
  if (showSelectedVariantImages) {
    const images = selectedVariant?.color?.images || [];
    const thumbnails: PDPThumbnailType[] = [...images];
    return {
      images,
      thumbnails,
      videos: [],
      totalCount: thumbnails.length
    };
  } else {
    const mainImage: ProductImageViewModel = {
      id: 'main-image',
      imageUrl: data?.mainImageUrl
    };
    let images = [];
    data?.mainImageUrl && images.push(mainImage);
    data?.images && data?.images?.length && (images = [...images, ...(data?.images || [])]);
    const thumbnails: PDPThumbnailType[] = [...images, ...videosThumbnails];
    return {
      images,
      thumbnails,
      videos
    };
  }
}